@if ((liveAlerts$ | async)?.length) {
  <div class="alert-toast-stack">
    <app-alert-preview-stack
      [loading]="false"
      [hasError]="false"
      [alerts]="(liveAlerts$ | async) ?? []"
      (dismiss)="dismiss($event)"></app-alert-preview-stack>
  </div>
}
